module.exports = __webpack_public_path__ + "static/media/top6.d7f19f17.jpg";